import moment from 'moment';
import styled from 'styled-components';

export const dateToCommonFormat = date => moment(date).format('DD MMM YYYY');

export const DateOrderFix = styled.span`
  direction: ltr;
  display: inline-flex;
`;
